module.exports = __webpack_public_path__ + "img/DE00452.060ab0ee.png";